import type { ResolvedAtlassianLink } from '../AudioBriefingPopupSourcesPanel';
const SupportedProducts = {
	Confluence: 'confluence',
} as const;
export type SupportedProduct = (typeof SupportedProducts)[keyof typeof SupportedProducts];

const SupportedResourceTypes = {
	Page: 'page',
	Blog: 'blog',
} as const;
export type SupportedResourceType =
	(typeof SupportedResourceTypes)[keyof typeof SupportedResourceTypes];

export const SupportedResources = {
	confluence: ['page', 'blog'],
} satisfies Record<SupportedProduct, SupportedResourceType[]>;

const isValidProduct = (value?: string): value is SupportedProduct => {
	return !!value && Object.values(SupportedProducts).includes(value as SupportedProduct);
};

const isValidResourceType = (value?: string): value is SupportedResourceType => {
	return !!value && Object.values(SupportedResourceTypes).includes(value as SupportedResourceType);
};

export const isSupportedResource = (resolvedLink?: ResolvedAtlassianLink): boolean => {
	if (!resolvedLink) {
		return false;
	}

	const { ari, product, resourceType } = resolvedLink;
	if (!ari || !isValidProduct(product) || !isValidResourceType(resourceType)) return false;
	return SupportedResources[product].includes(resourceType);
};
